module.exports = __webpack_public_path__ + "static/media/guan.92f79bd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guan.mp4
// module id = +x5L
// module chunks = 1